<template>
  <div id="contact">
    <Navbar />
    <div class="underlay"></div>
    <div class="container page-content">
      <h1 class="mb-4">Contact Frizlen Group</h1>
      <div
        v-if="page.attributes"
        v-html="page.attributes.body.value"
      ></div>
    </div><!-- /.container -->
    <transition name="fade">
      <div
        v-if="loading == true"
        class="spinner d-flex justify-content-center mb-3"
      >
        <b-spinner style="width: 5rem; height: 5rem;" label="Loading..."></b-spinner>
      </div>
    </transition>
  </div><!-- /#about -->
</template>

<script>
import Navbar from './Navbar'
import axios from 'axios'

export default {
  data() {
    return {
      loading: true,
      page: {}
    }
  },
  components: {
    Navbar
  },
  created() {
    this.getPage()
  },
  methods: {
    getPage() {
      axios.get('https://buffalofts.com/jsonapi/node/frizlen_page/ac042712-800a-4160-be1c-a921dcd084f6').then(response => {
        this.page = response.data.data
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
#contact {
  background: url(/static/backgrounds/portfolio.jpg) no-repeat center center fixed;
  background-size: cover;
  padding-top: 100px;
  min-height: 100vh;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue